import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";

import { ISDUIResponsiveValue } from "@faire/retailer/components/SDUI/__internal__/Styling/responsiveValues";

/**
 * A helper component to convert SDUI server responsive values into RSC-friendly content that is client responsive.
 */
export const SDUIResponsiveContent = <T, U extends ISDUIResponsiveValue<T>>({
  defaultValue,
  convertValueToReactElement,
  serverResponsiveValues,
}: {
  defaultValue: T;
  convertValueToReactElement: (value: T) => React.ReactNode;
  serverResponsiveValues?: U;
}) => {
  if (!serverResponsiveValues) {
    return convertValueToReactElement(defaultValue);
  }

  const mobileValue = serverResponsiveValues.mobile_and_above ?? defaultValue;
  const tabletValue = serverResponsiveValues.tablet_and_above ?? mobileValue;
  const desktopAndAboveValue =
    serverResponsiveValues.desktop_and_above ?? tabletValue;

  return (
    <ResponsiveContentV2
      mobile={convertValueToReactElement(mobileValue)}
      tablet={convertValueToReactElement(tabletValue)}
      desktopAndAbove={convertValueToReactElement(desktopAndAboveValue)}
      noJS
    />
  );
};
